var _style, _path, _rect, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLnk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3D6599;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.4,60H74.8c-15.1,0-28.4,12.1-28.4,28.4v335.3c0,15.7,13.3,27.8,28.4,27.8h334.1 c15.7,0,29.1-12.7,29.1-28.4V88.4C437.9,72.1,424.6,60,409.4,60z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 206.5,
    className: "st1",
    width: 58.1,
    height: 187.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 132.3,
    cy: 147.2,
    r: 33.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.1,394.1v-90.8c0-21.8-0.6-49.6-30.3-49.6c-30.3,0-35.1,23.6-35.1,47.8v92.6h-58.1V206.5h55.7v25.4h0.6 c11.5-19.4,32.7-30.9,55.1-30.3c58.7,0,69.6,38.7,69.6,89l0.6,102.9h-58.1V394.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnk);
export default __webpack_public_path__ + "static/media/lnk.87d3974209c7c0753d2d5c7997d16502.svg";
export { ForwardRef as ReactComponent };